export enum ContactListStatusEnum {
  PROCESSING = 'PROCESSING',
  READY = 'READY',
  CLASSIFYING = 'CLASSIFYING',
  FAILED = 'FAILED'
}